<template>
    <div class="association_item">
        <component
            :is="tileComponent"
            v-bind="tileAttributes"
            class="association_block text_center"
            :class="{
                private: tile.premiumOnly,
                unlocked: isPremiumUser
            }"
        >
            <div class="block_image">
                <div class="image_wrapper">
                    <picture
                        :key="isPremiumUser ? 'YES' : 'NO'"
                        v-full-image-path="tileImage"
                    />
                </div>
                <div class="block_title second_font">
                    {{ tile.title }}
                </div>
            </div>
        </component>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import isExternalLink from '@/helpers/isExternalLink';

export default {
    props: {
        tile: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters({
            isPremiumUser: 'isPremiumUser'
        }),

        link() {
            return this.tile.redirect;
        },

        isExternalLink() {
            return isExternalLink(this.link);
        },

        tileComponent() {
            if (this.tile.premiumOnly && !this.isPremiumUser) {
                return 'button';
            }

            return this.isExternalLink ? 'a' : 'nuxt-link';
        },

        tileAttributes() {
            return this.isExternalLink
                ? {
                      href: this.link,
                      target: '_blank',
                      rel: 'noopener noreferrer'
                  }
                : {
                      to: this.link
                  };
        },

        tileImage() {
            const { premiumOnly, premiumOnlyImage, image } = this.tile;

            if (!premiumOnly) {
                return image;
            }

            return this.isPremiumUser ? image : premiumOnlyImage;
        }
    }
};
</script>
